import React from 'react';
import { faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    onFieldChange, SimpleTable
} from '../common/forms/FormElements';
import CommonContext from '../Common';
import SlideForm from '../common/forms/SlideForm';

export class JobDashboardDetailForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const stateBase = {
            show: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        this.populateState();
    }

    onChange = onFieldChange.bind(this);

    onClose(response) {
        this.setState({ show: false });
        this.context.setFormOpened(false);
        this.props.onClose(response);
    }

    open = async (id) => {
        this.setState({ show: true, loading: true });
        this.context.setFormOpened(true);

        this.setState({
            loading: false,
        });
    };

    async populateState() {
        this.setState((state) => ({
            loading: false,
        }));
    }

    renderDetail = () => {
        var data = this.props?.data?.details;

        return data?.map((detail, i) => (
            <tr>
                <td>{detail.driver}</td>
                <td>{detail.equipment}</td>
            </tr>
        ));
    }

    render() {
        return (
            <SlideForm
                loading={this.state.loading}
                show={this.state.show}
                id="detailForm"
                formIcon={faScrewdriver}
                formTitle='Job Details'
                ref={this.formRef}
                setIsValidated={(value) => { this.setState({ formValidated: value }); }}
                onClose={this.onClose}
            >

              
                <SimpleTable
                    className="mb-0"
                    id="jobDashboardDetail"
                    noTopBorder
                    permission="timesheet"
                    tableHeaderLabels={[
                        {
                            name: 'Driver',
                            class: 'ct-job-number',
                        },
                        {
                            name: 'Equipment',
                            class: 'ct-job-name',
                        }
                    ]}
                    editable={false}
                    entities={[{ driver: 'A', equipment: 'B' }, { driver: 'C', equipment: 'D' }]}
                    rowRenderer={
                        this.renderDetail
                    }
                    noDataText="No detail found."
                />

            </SlideForm>
        );
    }
}
